export default __webpack_public_path__ + "static/image12-44acd988eaf5914c9ca9390c2bd373d8.gif";